import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    height: '82px',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
    display: 'flex',
    padding: '8px 24px',
  },
  logoContainer: {
    minWidth: '66px',
    maxWidth: '300px',
    height: '66px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: 'auto',
      height: 'auto',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  logoPlaceholder: {
    backgroundColor: foundations.colors.gray300,
    border: `1px dashed ${foundations.colors.gray700}`,
    '& svg': {
      fill: foundations.colors.gray700,
      width: '30px',
      height: '30px',
    },
  },
  navMenu: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 16px',
    gap: '8px',
    borderRadius: '8px',
    fontWeight: foundations.typography.fontWeight.medium,
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
});
